import _ from 'lodash';
let env = process.env;

let config = {
  development: {
    homeUrl: 'http://localhost:3000',
    baseUrl: 'http://localhost:4343/api/v1',
  },

  production: {
    homeUrl: 'https://sharambeaprop.com',
    baseUrl: 'https://sharambea-final-api-44cff14947e3.herokuapp.com/api/v1',
  },
};

export default _.extend({}, config.general, config[env.NODE_ENV]);
